import React, {Component} from 'react';
import AuthService from '../oauth/services/AuthService';

const AuthContext = React.createContext({
  signinSilent: () => {},
  signinRedirectCallback: () => {},
  logout: () => {},
  silentLogout: () => {},
  isAuthenticated: () => {},
  signinRedirect: () => {},
  signinSilentCallback: () => {},
  createSigninRequest: () => {},
});

export const AuthConsumer = AuthContext.Consumer;

export class AuthProvider extends Component<{children: React.ReactNode}> {
  authService;
  constructor(props: any) {
    super(props);
    this.authService = new AuthService();
  }
  render() {
    return (
      <AuthContext.Provider value={this.authService}>
        {this.props?.children}
      </AuthContext.Provider>
    );
  }
}
